import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'hub-title',
  standalone: true,
  imports: [ButtonModule],
  template: `
    <div class="tw-flex tw-items-center tw-gap-4">
      @if (pathname !== '/') {
        <p-button (onClick)="back()" icon="pi pi-arrow-left" [rounded]="true" [text]="true" />
      }
      <h1 class="tw-text-3xl tw-my-4" [style]="{ color: 'var(--primary-color)' }">{{ text }}</h1>
    </div>
  `,
  styleUrl: './title.component.scss',
})
export class TitleComponent implements OnInit {
  @Input({ required: true }) text: string = '';
  private router = inject(Router);
  public pathname: string = '';

  ngOnInit(): void {
    this.pathname = location.pathname;
  }

  back() {
    this.router.navigate(['/']);
  }
}
